import { motion } from 'framer-motion';
import { useParams } from 'react-router';
import { Center, Column, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { useAppSelector } from '~/hooks/useAppSelector';
import { CSSProperties } from 'react';
import { UserProfession } from '~/enums/UserProfession';
import {
  EmptyFilteredFavorites,
  EmptyFilteredRecent,
  EmptyFilteredRecommendedPros,
} from '~/images/professionalHub';
import { TABS } from '../utils';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
/** centered fade-in wrapper on a motion.div; margins have no DS Box prop */
const wrapperStyle: CSSProperties = {
  maxWidth: '827px',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 40,
  marginBottom: 80,
};

export const EmptyFilteredList = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
    style={wrapperStyle}
  >
    <Description />
  </motion.div>
);

const Description = () => {
  const filter = useAppSelector((state) => state.user.professionalHubFilter);
  const params = useParams();
  const { type } = params;
  const profession = UserProfession.getName(filter);

  let title = '';
  let description = '';
  let Icon = null;

  switch (type) {
    case TABS.FAVORITES_LIST:
      Icon = EmptyFilteredFavorites;
      title = 'No professionals added yet!';
      // eslint-disable-next-line max-len
      description = `You have not added any ${profession} to your Favorites List yet. Add one to get started!`;
      break;
    case TABS.RECENT_PROFESSIONALS:
      Icon = EmptyFilteredRecent;
      title = 'No professionals yet!';
      // eslint-disable-next-line max-len
      description = `Your office has not recently worked with any ${profession} on GoTu yet. Connect with one to get started!`;
      break;
    case TABS.RECOMMENDED_PROS:
      Icon = EmptyFilteredRecommendedPros;
      title = `No new ${profession}s at this time!`;
      // eslint-disable-next-line max-len
      description = `We are actively searching for any ${profession} who meet the “New to You” criteria in your area. Please check back soon to see the results!`;
      break;
    default:
  }

  return (
    // width 400px has no DS token; passed as a string. gap 32→token 8.
    <Center width="400px" gap={8}>
      {Icon && <Icon />}
      <Column gap={2}>
        {/* NOTE(future-DS): legacy fontSize was 22px; no DS token (20/24), rounded to heading_4. */}
        <Typography color={colors.neutral['500']} bold size="heading_4" textAlign="center">
          {title}
        </Typography>
        <Typography color={colors.neutral['500']} textAlign="center">
          {description}
        </Typography>
      </Column>
    </Center>
  );
};
